import { createAction } from '@reduxjs/toolkit';
import { ICartProduct } from '../models/cart.model';
import { UploadStatus } from '../models/upload-status.model';

export const CART_FETCH = '[Cart] CART_FETCH';
export const CART_ADD_PRODUCT = '[Cart] ADD_PRODUCT';
export const CART_UPDATE_PRODUCT = '[Cart] UPDATE_PRODUCT';
export const CART_DELETE_PRODUCT = '[Cart] CART_DELETE_PRODUCT';
export const CART_CLEAR = '[Cart] CART_CLEAR';
export const CART_PAYMENT_TYPE_ID = '[Cart] PAYMENT_TYPE_ID';
export const CART_COMMENT = '[Cart] COMMENT';
export const CART_SET_UPLOAD_DISCOUNT_STATUS = '[Cart] SET_UPLOAD_DISCOUNT_STATUS';
export const CART_PROMO_CODE = '[Cart] PROMO CODE';

export const cartFetchAction = createAction<string>(CART_FETCH);
export const cartAddProductAction = createAction<ICartProduct>(CART_ADD_PRODUCT);
export const cartUpdateProductAction = createAction<{ product: ICartProduct, quantity: number }>(CART_UPDATE_PRODUCT);
export const cartDeleteProductAction = createAction<ICartProduct>(CART_DELETE_PRODUCT);
export const cartClearAction = createAction<void>(CART_CLEAR);
export const cartPaymentTypeIdAction = createAction<string>(CART_PAYMENT_TYPE_ID);
export const cartCommentAction = createAction<string>(CART_COMMENT);
export const cartPromoCodeAction = createAction<string>(CART_PROMO_CODE);
export const cartSetUploadDiscountStatusAction = createAction<UploadStatus>(CART_SET_UPLOAD_DISCOUNT_STATUS);
